import React  from 'react';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useUserProfileStore } from 'store/user/useUserProfileStore';
import DayJs from 'utils/Dayjs';

const Contact = () => {
	// Use user's profile store
	const [email, phoneNumber, lastOnline, address] = useUserProfileStore(state => [
		state.user.email,
		state.user.phoneNumber,
		state.user.lastOnline,
		state.address
	]);

	return (
		<Container className="p-4 space-y-2">
			{/* Email */}
			<div className="flex items-center space-x-2">
				<Title
					title="E-pasts"
					subtitle={email}
					className="flex-1"
				/>

				<Button
					small
					square
					icon="mail"
					to={`mailto:${email}`}
				/>
			</div>

			{/* Phone number */}
			<Show if={phoneNumber}>
				<div className="flex items-center space-x-2">
					<Title
						title="Telefons"
						subtitle={phoneNumber}
						className="flex-1"
					/>

					<Button
						small
						square
						icon="phone"
						to={`tel:${phoneNumber}`}
					/>
				</div>
			</Show>

			{/* Address information */}
			<Show if={address.country}>
				<div className="flex items-center space-x-2">
					<Title
						title="Adrese"
						subtitle={`${address.street}, ${address.city}, ${address.country}, ${address.zip}`}
						className="flex-1"
					/>

					<Button
						small
						square
						icon="map"
						disabled
					/>
				</div>
			</Show>

			{/* Last online information */}
			<Show if={lastOnline}>
				<div className="flex items-center space-x-2">
					<Title
						title="Pēdējo reizi pieslēdzies"
						subtitle={DayJs(lastOnline).format('D. MMM, YYYY HH:mm')}
						className="flex-1"
					/>

					<Button
						small
						square
						icon="wifi"
						disabled
					/>
				</div>
			</Show>
		</Container>
	);
};

export default Contact;